import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import {Router, NavigationEnd,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-modal-point-transferred',
  templateUrl: './modal-point-transferred.component.html',
  styleUrls: ['./modal-point-transferred.component.scss']
})
export class ModalPointTransferredComponent implements OnInit {

  @ViewChild('pointTransferredModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  point : any = {};
  message = '';
  myProfile: any = {};
  isShow = false;
  status = '';

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private router: Router, 
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.modalServ.onPointTransferred.subscribe(req => {
      this.getMyProfile();
      this.message = req.message;
      this.point = req.point;
      this.status = req.status;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onPointTransferredHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
    window.location.reload();
  }

  async getMyProfile(){
    this.myProfile = await this.utility.getMyProfile();
  }

  confirm() {
    this.hide();
    this.modalServ.onPointTransferredSuccess.emit({status: 'success'});
  }

  close() {
    this.hide();
    this.modalServ.onPointTransferredSuccess.emit({status: 'success'});
  }

  onEditImage() {
    
  }

}
